import { FormValues, SelectField, SelectFieldProps } from "@hex-insights/forms";
import { currencyOptions } from "../../../../Utilities";

export type CurrencyFieldProps<FV extends FormValues> = Omit<SelectFieldProps<FV, string>, "options">;

export function CurrencyField<FV extends FormValues>(props: CurrencyFieldProps<FV>) {
	return <SelectField {...props} options={currencyOptions} />;
}
